<template>
    <div class="condition-container" :style="conditionContainerStyle">
        <inner-children-renderer v-if="_child" :children="_child" />
        <div v-else></div>
    </div>
</template>

<script>
import Vue from 'vue';
import FEGORender from '@futuweb/fego-render';
const {
    rem: { rem }
} = require('@futuweb/fego-bridge');
const {
    plugins: { ComplexComp, condition },
    common: {
        env: { isPreRender }
    },
    store: { variable }
} = FEGORender;

import ChildItem from '../children/item/render/index.vue';
import { CHILD } from '../constant';

export default Vue.extend({
    name: 'condition-container',

    mixins: [
        ComplexComp.Inner.Parent.Mixins({
            [CHILD]: ChildItem
        })
    ],

    props: ['tpl'],

    data() {
        return {
            loaded: false,
            targetId: '',
            v: variable.data,
            loading: false
        };
    },
    watch: {
        v: {
            handler() {
                this.refresh();
            },
            deep: true
        }
    },

    computed: {
        defaultTargetId() {
            // eslint-disable-next-line max-len
            return this.tpl.children.find(
                (c) => c.props?.conditions === 'default' || c.props?.conditions.includes('default')
            )?.id;
        },
        _child() {
            const pageIsPreRender = Boolean(window?._params?.preRenderInfo);
            if (!this.loaded && !pageIsPreRender) {
                return null;
            }

            let r = this.tpl.children.find((c) => c?.id === this.targetId);
            if (!r) {
                r = this.tpl.children.find((c) => c?.id === this.defaultTargetId);
            }
            return r;
        },
        conditionContainerStyle() {
            return {
                minHeight: this.tpl.props.minHeight > 0 ? rem.str(this.tpl.props.minHeight) : 'auto'
            };
        }
    },

    async created() {
        if (isPreRender) {
            //如果是预渲染，直接返回defaultTargetId
            console.log('[condition-container] pre render mode return defaultTargetId: ', this.defaultTargetId);
            this.targetId = this.defaultTargetId || '';
            this.loaded = true;
            return;
        }

        await this.refresh(true);
        this.loaded = true;
    },

    methods: {
        async refresh(init = false) {
            // 这里不做锁处理，因为当计算条件较长时，此时variable被修改了。会造成无法正确计算var-fact相关内容
            // 防重复点击
            // if (this.loading) {
            //     return;
            // }
            this.loading = true;

            let targetId = '';
            try {
                targetId = await this.getStatus();
            } catch (err) {
                console.error('[condition-container] getStatus error: ', err);
            } finally {
                // this.loading = false;
            }

            if (!targetId) {
                targetId = this.defaultTargetId;
            }
            this.targetId = targetId;
        },

        async getStatus() {
            //当前project中的rule还取不到，暂时取pdData中的rule
            const result = await condition.getResult();
            for (let i = 0; i < this.tpl.children.length; i++) {
                const child = this.tpl.children[i];
                let checkConditions = child.props?.conditions || [];
                // 如果是字符串，转成数组, 为了兼容之前的写法
                if (typeof checkConditions === 'string') {
                    checkConditions = [checkConditions];
                }

                // 判断是否满足条件，conditions为为rule中params的id，只要命中一个即可，即为或的关系
                const isMatch = checkConditions.some((condition) => {
                    return result[condition]?.result === true;
                });
                // 从上往下找，找到第一个满足条件的就返回
                if (isMatch) {
                    return child.id;
                }
            }
        }
    }
});
</script>

<style lang="less" scoped>
.condition-container {
    height: auto !important;
}
</style>
